const educationAffairs = {
  strict: true,//严格模式
  namespaced: true,
  state: {
    
  },
  mutations: {
    
  }
}
export default educationAffairs